<ui-section>
  <ui-block>
    <ui-panel
      width="fill"
      class="hearing-list"
      [panelTitle]="pageTitle()"
      [title]="pageTitle()"
      [subtitle]="pageSubtitle()"
    >
      <div class="hearing-list-filters" data-testid="filter-controls">
        <ui-form
          #filterForm
          [config]="filterFormConfig"
          [(formValues)]="filterFormValues"
          [disabled]="isLoading()"
          [showFormErrors]="true"
        ></ui-form>
        <ui-button-group
          class="filter-actions"
          [buttonsConfig]="filterActionButtons"
          (buttonClick)="onFilterActionButtonClick($event)"
        ></ui-button-group>
      </div>

      <div
        *ngIf="isLoading()"
        class="state loading"
        data-testid="loading-state"
      >
        {{ hearingText.loading() }}
      </div>

      <div
        *ngIf="!isLoading() && errorState() as error"
        class="state error"
        data-testid="error-state"
      >
        <strong>{{ error.title }}</strong>
        <p *ngFor="let message of error.messages" class="message">
          {{ message }}
        </p>
      </div>

      <div
        *ngIf="!isLoading() && !errorState() && !hasHearings()"
        class="state"
        data-testid="empty-state"
      >
        {{ hearingText.empty() }}
      </div>

      <ui-grid
        *ngIf="!isLoading() && !errorState() && hasHearings()"
        width="fill"
        containerClass="no-panel"
        data-testid="grid-view"
        [rowData]="visibleHearings()"
        [columnDefs]="columnDefs()"
        [showPanelHeader]="false"
        [showBlankRowsOnLastPage]="true"
      ></ui-grid>
    </ui-panel>
  </ui-block>
</ui-section>
